import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

interface NavLink {
  name: string;
  href: string;
  icon?: React.FC<{ className: string }>;
}

export const socialLinks: NavLink[] = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/fydoin',
    icon: FaFacebook,
  },
  {
    name: 'Linked In',
    href: 'https://www.linkedin.com/company/fydoin',
    icon: FaLinkedin,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/greet.fydo/',
    icon: FaInstagram,
  },
];
